import { Injectable, Injector } from '@angular/core';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Globals } from '../global';
import { ApiRoutes } from '../../shared/api-routes';
@Injectable({
  providedIn: 'root',
})
export class ApiCallingService {
  constructor(
    public http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    private globals: Globals,
    private injector: Injector,
  ) {}

  isPublicPage(): boolean {
    const currentUrl = window.location.pathname.toLowerCase();
    const publicPages = ['/dashboard', '/login'];
    return publicPages.some((page) => currentUrl.includes(page));
  }

  getHeader() {
    let httpHeaders = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json')
      .set('Pragma', 'no-cache')
      .set('Cache-Control', 'no-cache, no-store, must-revalidate');
    return httpHeaders;
  }

  getAuthHeader() {
    let token = localStorage.getItem('Auth-token');
    let httpHeaders = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });
    return httpHeaders;
  }
  getAuthPostHeader() {
    let token = localStorage.getItem('Auth-token');
    let httpHeaders = new HttpHeaders({
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    });
    return httpHeaders;
  }

  callAuthAPI(body: object, type: String, url: string): Observable<any> {
    let token = localStorage.getItem('Auth-user');
    if (!token) {
      this.router.navigate(['/login']);
    }
    let headers: HttpHeaders = this.getAuthHeader();
    let options = {
      headers: headers,
    };
    if (type == 'POST') {
      return this.http.post(url, body, options);
    } else if (type == 'PUT') {
      return this.http.put(url, body, options);
    } else if (type == 'DELETE') {
      return this.http.delete(url, options);
    } else {
      return this.http.get(url, options);
    }
  }

  getIP(): Observable<string> {
    // return this.http.get<any>('https://api.ipify.org/?format=json').pipe(
    //   map(res => res.ipAddress), // depends on provider's format
    //   catchError(() => of('NA'))
    // );
    return of('NA'); // For testing purposes, returning a dummy IP
  }

  callAuthPostAPI(body: object, type: string, url: string): Observable<any> {
    const storedUserData = JSON.parse(localStorage.getItem('Auth-user')!);
    const token = this.globals.getToken();
    const loginType = 'Web';
    const defaultDescription = `IP:N/A, other:${navigator.userAgent}`;
    const publicKey = environment.PublicKey;
    const description =
      (body as any).description && (body as any).description.trim() !== ''
        ? (body as any).description
        : defaultDescription;

    body = { ...body, loginType, publicKey };

    const headers: HttpHeaders = this.getAuthPostHeader();
    const options = { headers };

    let request$: Observable<any>;

    switch (type) {
      case 'POST':
        request$ = this.http.post(url, body, options);
        break;
      case 'PUT':
        request$ = this.http.put(url, body, options);
        break;
      case 'GET':
        request$ = this.http.get(url, options);
        break;
      case 'DELETE':
        request$ = this.http.delete(url, options);
        break;
      default:
        return throwError(() => new Error('Invalid request type'));
    }

    return request$.pipe(
      catchError((error) => {
        console.error('API error:', error);

        return throwError(() => error);
      }),
    );
  }

  callAPI(body: object, type: String, url: string): Observable<any> {
    return this.getIP().pipe(
      switchMap((ip: string) => {
        let headers: HttpHeaders = this.getHeader();
        const loginType = 'web';
        const description = `IP:N/A, other:${navigator.userAgent}`;
        const publicKey = environment.PublicKey;
        body = { ...body, description, publicKey, loginType };
        let options = {
          headers: headers,
        };
        if (type == 'POST') {
          return this.http.post(url, body);
        } else if (type == 'PUT') {
          return this.http.put(url, body);
        } else if (type == 'GET') {
          return this.http.get(url);
        } else if (type == 'DELETE') {
          return this.http.delete(url);
        } else {
          return this.http.get(url);
        }
      }),
      catchError((err) => {
        console.error('Error during API call:', err);
        return throwError(() => err);
      }),
    );
  }

  handleSuccess(res: any) {
    if (res.responseCode == 200) {
      return true;
    } else {
      return false;
    }
  }

  logout(payload: any, type: string = 'normal') {
    let msg = 'Log out successfully';
    if (type != 'normal') {
      msg = 'You have been logged out forcefully!';
    }

    this.callAuthPostAPI(payload, 'POST', ApiRoutes.URLS.LOGOUT).subscribe(
      (res) => {
        localStorage.clear();
        this.messageService.clear();
        this.messageService.add({ severity: 'success', detail: msg });
        this.router.navigate(['login']);
      },
      (error) => {
        localStorage.clear();
        this.messageService.clear();
        this.messageService.add({ severity: 'success', detail: msg });
        this.router.navigate(['login']);
      },
    );
  }

  // showTosterMessage(message: any) {
  //   const idleService = this.injector.get(IdleService);
  //   idleService.toastMessageSignal.set({
  //     severity: message.severity,
  //     summary: message.summary,
  //     detail: message.detail,
  //   });
  // }

  // passColumnWidth(columnId: any, width: any): void {
  //
  //   let payload = {
  //     userId: this.globals.getUserId(),
  //     columnWidth: width + 'px',
  //     columnId: btoa(String(columnId)),
  //     loginType: '',
  //   };
  //   this.callAuthPostAPI(
  //     payload,
  //     'POST',
  //     ApiRoutes.URLS.GET_COLUMN_WIDTH
  //   ).subscribe({
  //     next: (res: any) => {
  //       const Data = JSON.parse(res);
  //       if (this.handleSuccess(Data)) {
  //         // this.showTosterMessage({
  //         //   severity: 'success',
  //         //   summary: 'Success',
  //         //   detail:
  //         //     Data.responseMessage.charAt(0).toUpperCase() +
  //         //     Data.responseMessage.slice(1).toLowerCase(),
  //         // });
  //       }
  //     },
  //     error: (response) => {
  //       const err = JSON.parse(response.error);
  //       this.showTosterMessage({
  //         severity: 'error',
  //         summary: 'Error',
  //         detail:
  //           err.responseMessage.charAt(0).toUpperCase() +
  //           err.responseMessage.slice(1).toLowerCase(),
  //       });
  //     },
  //   });
  // }
}
